var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

const SvgFindAPlaceToRent = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "find-a-place-to-rent_svg__Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".find-a-place-to-rent_svg__cls-1{fill:none;stroke:#2d4658;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "find-a-place-to-rent_svg__Shape_502",
  "data-name": "Shape 502",
  className: "find-a-place-to-rent_svg__cls-1",
  d: "M30 15.18l-13.18-12a1.22 1.22 0 00-1.64 0L2 15.18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.44 28.74A7.76 7.76 0 1127.1 16v-.17a.74.74 0 00-.27-.57L16.49 6.43a.75.75 0 00-1 0L5.15 15.84a.73.73 0 00-.25.55v12.18a1.35 1.35 0 001.36 1.35h12.18z",
  fill: "#00c5ba"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "find-a-place-to-rent_svg__Oval_18",
  "data-name": "Oval 18",
  className: "find-a-place-to-rent_svg__cls-1",
  d: "M22.12 27.42a5.52 5.52 0 10-5.51-5.51 5.52 5.52 0 005.51 5.51z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "find-a-place-to-rent_svg__Shape_387",
  "data-name": "Shape 387",
  className: "find-a-place-to-rent_svg__cls-1",
  d: "M30 29.78l-3.95-4"
})));

export default SvgFindAPlaceToRent;